import { staticCommandsDataMSSQL } from '../../constants/mocks/databaseCommandsMsSQL';
import { staticCommandsDataMYSQL } from '../../constants/mocks/databaseCommandsMySQL';
import { staticCommandsDataPOSTGRES } from '../../constants/mocks/databaseCommandsPostgres';
import { ScriptCommands } from '../../types/dashboard';
import { ContentKey } from '../../types/steps';

const COMMANDS_BY_ENGINE: Record<string, ScriptCommands> = {
  [ContentKey.MYSQL]: staticCommandsDataMYSQL,
  [ContentKey.MSSQL]: staticCommandsDataMSSQL,
  [ContentKey.POSTGRES]: staticCommandsDataPOSTGRES,
};

/**
 * Command set for a project's engine (PROJECT_CONFIG `system`, any case).
 * Undefined for an unknown engine: there is deliberately no fallback to another engine's commands.
 */
export function commandsForEngine(system: string | undefined): ScriptCommands | undefined {
  return COMMANDS_BY_ENGINE[(system ?? '').trim().toLowerCase()];
}
